import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router, RouterState, RouterStateSnapshot } from '@angular/router';
import Swal from 'sweetalert2';
import { AppSettings } from '~shared/constants/app-settings';
import { RegisterModel } from '~shared/models/usuario';
import { UsuariosService } from '../../../shared/servicios/usuarios.service';
import { HeaderNComponent } from '../header-n/header-n.component';
import { environment } from '~environment';

@Component({
  selector: 'app-modal-reg',
  templateUrl: './modal-reg.component.html',
  styleUrls: ['./modal-reg.component.scss']
})
export class ModalRegComponent extends HeaderNComponent implements OnInit {

  registerForm;

  idLider: string;
  lider: { id_lider: string; lider: '' };

  vistaModal: boolean = false;

  msges: string[] = [];

  @Output() modalSelect = new EventEmitter();
  @Input() showClose: boolean = true;

  activeRoute;
  showErrorSpace: boolean = false;

  constructor(public usuarioService: UsuariosService, public router: Router, private activatedRoute: ActivatedRoute, private _formBuilder: FormBuilder) {
    super(router)
    // this.cargarLider();

  }

  ngOnInit(): void {
    // this.deteleItemsInitial();
    // this.createForm();
    // this.activeRoute = this.router.url;
    if (this.activatedRoute.snapshot.params.id) {
      const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com/register/' + this.activatedRoute.snapshot.params.id : 'https://accounts.triidy.com/register/' + this.activatedRoute.snapshot.params.id;
      window.open(url, '_self')
    } else {
      const url = environment.dbUsed === 'pruebas' ? 'https://accounts.qa.triidy.com/register/' : 'https://accounts.triidy.com/register/';
      window.open(url, '_self')
    }
  }

  deteleItemsInitial() {
    sessionStorage.removeItem(btoa('nombreReg-tienda'));
    sessionStorage.removeItem(btoa('correoReg-tienda'));
    sessionStorage.removeItem(btoa('disabledInp-tienda'));
  }

  createForm() {
    this.registerForm = new FormGroup({
      correo: new FormControl('', [Validators.required, Validators.maxLength(60), Validators.email]),
      nombreT: new FormControl('', [Validators.required, Validators.maxLength(45), Validators.pattern("^[A-Za-z0-9À-ÖØ-öø-ÿ][A-Za-z0-9À-ÖØ-öø-ÿ\\s]*$")]),
      terms: new FormControl(false, [Validators.required]),
      politics: new FormControl(false, [Validators.required]),
      sendSMS: new FormControl(false)
    });

    this.changesOnForm();
  }

  changesOnForm() {
    this.onChangesEmail();
    this.onChangesNombreT();
    this.onChangesTerms();
    this.onChangesPyA();
  }

  cargarLider(): void {
    if (this.activatedRoute.snapshot.params.id !== undefined) {
      this.activatedRoute.params.subscribe(() => {
        const state: RouterState = this.router.routerState;
        const snapshot: RouterStateSnapshot = state.snapshot;
        if (this.activatedRoute.snapshot.params.id) {
          sessionStorage.setItem('Tienda', this.activatedRoute.snapshot.params['id']);
          this.idLider = this.activatedRoute.snapshot.params.id;
        } else {
          this.idLider = AppSettings.LIDER_DEFAULT;
        }
        this.loadInfoLider();
      });
    } else if (sessionStorage.getItem('Tienda') !== null && sessionStorage.getItem('Tienda') !== undefined) {
      sessionStorage.setItem('Tienda', sessionStorage.getItem('Tienda'));
      this.idLider = sessionStorage.getItem('Tienda');
      this.loadInfoLider();
    } else {
      this.idLider = AppSettings.LIDER_DEFAULT;
      this.loadInfoLider();
    }
  }

  loadInfoLider(): void {
    this.usuarioService.getLider(this.idLider).subscribe((response) => {
      if (response) {
        this.lider = response[0];
      }
    }, (err) => {
      sessionStorage.removeItem('Tienda');

      this.cargarLider();

    });
  }

  onChangesEmail() {
    const inputMail = this.registerForm.get('correo');
    inputMail.valueChanges.subscribe((val) => {
      if (val.length > 3 && val.indexOf(' ') >= 0) {
        let msg = 'Elimina el espacio que tienes dentro de tu correo electrónico para continuar con tu registro';
        // this.msges.push(msg)
        this.showErrorSpace = true;
        this.generateErrorUser(msg);
      } else {
        this.showErrorSpace = false;
      };
    })
  }

  onChangesNombreT() {
    const inputMail = this.registerForm.get('nombreT');
    inputMail.valueChanges.subscribe((val) => {
      if (this.registerForm.controls.nombreT.errors?.pattern) {
        let msg = 'Tu nombre de tienda esta incorrecto, debe tener algun caracter no permitido';
        // this.msges.push(msg)
        this.generateErrorUser(msg);
      }
    })
  }

  onChangesTerms() {
    const inputMail = this.registerForm.get('terms');
    inputMail.valueChanges.subscribe((val) => {
      if (this.registerForm.controls.terms.errors?.required) {
        let msg = 'Para continuar con el registro debes aceptar los términos y condiciones';
        // this.msges.push(msg)
        this.generateErrorUser(msg);
      }
    })
  }

  onChangesPyA() {
    const inputMail = this.registerForm.get('politics');
    inputMail.valueChanges.subscribe((val) => {
      if (this.registerForm.controls.politics.errors?.required) {
        let msg = 'Para continuar con el registro debes aceptar el tratamiento de datos personales y aviso de privacidad';
        // this.msges.push(msg)
        this.generateErrorUser(msg);
      }
    })
  }

  onFocusOutEventEmail() {
    /* const inputMail = this.registerForm.get('correo');
    console.log(inputMail)
    if (inputMail.errors['email']) {
      let msg = 'No es un correo electronico';
      this.msges.push(msg)
      this.generateErrorUser();
    } else {

    }

    if (inputMail.errors['required']) {
      let msg = 'Falta el correo electronico';
      this.msges.push(msg)
      this.generateErrorUser();
    }; */
  }

  getControl(control: string): AbstractControl {
    /* tslint:disable */
    return this.registerForm.get(control);
    /* tslint:enable */
  }

  // REGISTERFORM
  get correo() { return this.registerForm.get('correo'); }

  get nombreT() { return this.registerForm.get('nombreT'); }
  get terms() { return this.registerForm.get('terms'); }
  get politics() { return this.registerForm.get('politics'); }
  get sendSMS() { return this.registerForm.get('sendSMS'); }

  setObjectUserRegister(valueForm: RegisterModel): RegisterModel {
    return {
      correo: valueForm.correo,
      nombreT: valueForm.nombreT,
      terms: valueForm.terms,
      politics: valueForm.politics,
      sendSMS: valueForm.sendSMS,
    };
  }

  registroTienda(): void {
    const valueForm: any = { ...this.registerForm.value, };
    const usuario = this.setObjectUserRegister(valueForm);
    const terms = this.setObjectUserRegister(valueForm);
    const politics = this.setObjectUserRegister(valueForm);
    const sendSMS = this.setObjectUserRegister(valueForm);

    this.usuarioService.preRegistroUsuario(usuario, this.lider.id_lider).subscribe((data) => {
      sessionStorage.setItem(btoa('nombreReg-tienda'), btoa(usuario.nombreT));
      sessionStorage.setItem(btoa('correoReg-tienda'), btoa(usuario.correo));
      sessionStorage.setItem(btoa('disabledInp-tienda'), btoa('true'));
      if (this.activeRoute !== '/registrate' && !this.activeRoute.includes('/registro-comercio')) this.router.navigate(['/registrate'], { state: { redirect: true } });
      else this.modalSelect.emit(false);
    });
  }

  generateErrorUser(msg: any, resp?: boolean) {
    // console.log(this.msges)
    let img = '../../assets/images/alert.png';
    Swal.fire({
      allowOutsideClick: false,
      title: `<b style="color: #FF780B; font-weight: 700;"><img src="${img}"/>¡Cuidado!</b>`,
      html:
        '<span style="color: #656E90; text-align: justify; display: block; font-size: medium;"><ul>' + msg + '</ul></span>',
      // footer: ' <span style="color: red; font-size: 0.8vw"> Recuerda que se eliminara permanentemente, las tiendas no veran mas tu producto <span>',
      confirmButtonText: resp ? 'Iniciar Sesión' : 'Aceptar',
      confirmButtonColor: '#FF780B',
      showCancelButton: resp,
      cancelButtonText: 'Cancelar',
      reverseButtons: true,
      showClass: {
        popup: 'animate__animated animate__fadeInDown'
      },
      hideClass: {
        popup: 'animate__animated animate__fadeOutUp'
      },
      customClass: {
        cancelButton: 'cancel-button-class',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        if (resp) this.redirigirInicioSesion();
      } else if (result.isDismissed) {

      }
    })
  }

  redirigirInicioSesion(): void {
    this.router.navigateByUrl('/iniciar-sesion');
    this.closeModal();
  }

  closeModal() {
    this.modalSelect.emit(false);
  }

}
